import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicReverse({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M5.62 7.28a.8.8 0 01.07 1.05l-.07.09a.8.8 0 01-1.05.07l-.09-.07-2.6-2.6a.8.8 0 01-.07-1.05l.07-.09 2.6-2.6A.8.8 0 015.7 3.13l-.07.09-1.24 1.23H9.5a4.85 4.85 0 01.22 9.7H4.54a.8.8 0 01-.1-1.6H9.5a3.25 3.25 0 00.19-6.5h-5.3l1.23 1.23z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicReverse.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicReverse.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicReverse svgRef={ref} {...props} />);
export default ForwardRef;
